import { component } from 'picoapp'
import $ from 'jquery';
import 'slick-carousel';

export default component((node, ctx) => {
  console.log(node);
  $(node).slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    accessibility: false,
    arrows: true,
    prevArrow: $('.prev'),
    nextArrow: $('.next'),
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        centerMode: true,
        centerPadding: "10px",
        infinite: true
      }
    },{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        centerMode: true,
        infinite: true,
        arrows: false,
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "60px",
        infinite: true,
        arrows: false
      }
    }]
  })
});